import { CPopover } from './CPopover.js';

const CPopoverPlugin = {
    install: (app) => {
        app.component(CPopover.name, CPopover);
    },
};

export { CPopover, CPopoverPlugin };
//# sourceMappingURL=index.js.map
